<script setup lang="ts">
/**
 * 品牌標記：一本単行本，封面中央的 T 同時是書籤緞帶，底部是書口。
 *
 * 用 currentColor 而不是固定的墨色：它就在「Tanko」字標旁邊，兩者必須同色，而且
 * 深色模式下固定的近黑色會整個消失在深色側邊欄裡。favicon 與主畫面圖示另有帶底色的
 * 版本，那些不能繼承文字顏色。
 *
 * viewBox 貼齊圖形本身的邊界（原稿 512 畫布上的 147,120 到 365,377），因此呼叫端給
 * 高度就好，不會像原稿那樣四周帶一圈空白。
 */
withDefaults(defineProps<{ size?: number }>(), { size: 22 })
</script>

<template>
  <svg
    :height="size"
    :width="size * 218 / 257"
    viewBox="147 120 218 257"
    fill="none"
    aria-hidden="true"
    class="tanko-mark"
  >
    <g transform="translate(7 8)">
      <path
        d="M166 112H326Q358 112 358 144V345Q358 369 334 369H175Q140 369 140 334V141Q140 112 166 112Z M188 158H310V193H269V289L249 275L229 289V193H188Z M178 317Q164 317 164 333Q164 347 180 347H334V321H182Q179 321 178 317Z"
        fill-rule="evenodd"
        fill="currentColor"
      />
      <path d="M184 334H322" stroke="currentColor" stroke-width="5" stroke-linecap="round" />
    </g>
  </svg>
</template>
